(function () {
  'use strict';

  var BLOCK_ID = 'upcart-cart-recommendation';
  var SKELETON_ID = 'upcart-cart-recommendation-skeleton';
  var MOUNT_ID = 'upcart-cart-recommendation-mount';
  var GIFT_SUMMARY_ID = 'upcart-gifts-summary';
  var TRUST_SAVINGS_ID = 'upcart-cart-savings';
  var TRUST_BADGE_ID = 'upcart-cart-trust-badge';
  var HIDDEN_ATTR = 'data-upcart-trust-upsell-hidden';
  var SUPPRESS_STYLE_ID = 'upcart-trust-upsell-suppress-style';
  var MASK_PRODUCT_ID = 15698816336202;
  var MASK_HANDLE = 'weighted-sleep-mask';
  var ANIMAL_COLLECTION_HANDLE = 'weighted-animals-only';
  var BUNDLE_DISCOUNT = 10;

  var observer = null;
  var rootFinder = null;
  var renderTimer = null;
  var isRendering = false;
  var renderPending = false;
  var upcartOpenHooked = false;
  var upcartHookTimer = null;
  var productDataPromise = null;
  var cartDataPromise = null;
  var cachedCart = null;

  /* Custom single-card upsell:
     ab-cart-trust + ab-cart-trust-restart-v2
     ab-cart-trust-restart keeps native UpCart carousel. */
  function isEnabled() {
    var html = document.documentElement;
    if (html.classList.contains('ab-cart-trust-restart-v2')) return true;
    if (html.classList.contains('ab-cart-trust-restart')) return false;
    return html.classList.contains('ab-cart-trust');
  }

  function getUpcartDoc() {
    return window.upcartDocumentOrShadowRoot || document;
  }

  function getCartRoot() {
    var doc = getUpcartDoc();
    var root =
      doc.querySelector(
        '#UpcartPopup, #CartPopup, upcart-drawer, #upcart-drawer, .upcart-drawer, #upCart, .upcart-cart, [class*="upcart-cart"]'
      ) || null;

    if (!root && doc && doc.nodeType === 11) root = doc;
    return root;
  }

  function getMoneyFormat() {
    return (window.UPCART_CART_TRUST && window.UPCART_CART_TRUST.moneyFormat) || '${{amount}}';
  }

  function formatMoney(cents) {
    var amount = (Math.max(0, cents) / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(Math.max(0, cents) / 100));

    var formatted = getMoneyFormat()
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);

    var container = document.createElement('div');
    container.innerHTML = formatted;
    return container.textContent || '';
  }

  function normalizePrice(value) {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string') return 0;
    return Math.round(parseFloat(value.replace(',', '.')) * 100) || 0;
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    return url.indexOf('//') === 0 ? window.location.protocol + url : url;
  }

  function isFreeGift(item) {
    var properties = (item && item.properties) || {};
    return (
      !item ||
      (item.final_price === 0 && item.original_price === 0) ||
      properties._free_product === true ||
      properties._free_product === 'true'
    );
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Request failed: ' + response.status);
      return response.json();
    });
  }

  function loadCartData(forceRefresh) {
    if (!forceRefresh && cachedCart) return Promise.resolve(cachedCart);
    if (cartDataPromise) return cartDataPromise;

    cartDataPromise = fetchJson('/cart.js')
      .then(function (cart) {
        cachedCart = cart;
        return cart;
      })
      .finally(function () {
        cartDataPromise = null;
      });

    return cartDataPromise;
  }

  function invalidateCartData() {
    cachedCart = null;
  }

  function loadProductData() {
    if (productDataPromise) return productDataPromise;

    productDataPromise = Promise.all([
      fetchJson('/collections/' + ANIMAL_COLLECTION_HANDLE + '/products.json?limit=250'),
      fetchJson('/products/' + MASK_HANDLE + '.js')
    ]).then(function (responses) {
      var animals = (responses[0].products || []).map(function (product) {
        return {
          id: product.id,
          title: product.title,
          handle: product.handle,
          image: product.images && product.images[0] ? product.images[0].src : '',
          variants: (product.variants || []).map(function (variant) {
            return {
              id: variant.id,
              title: variant.title,
              available: variant.available,
              price: normalizePrice(variant.price),
              compareAtPrice: normalizePrice(variant.compare_at_price)
            };
          })
        };
      });

      var maskProduct = responses[1];
      var mask = {
        id: maskProduct.id,
        title: maskProduct.title,
        handle: maskProduct.handle,
        image: normalizeImageUrl(maskProduct.featured_image),
        variants: (maskProduct.variants || []).map(function (variant) {
          return {
            id: variant.id,
            title: variant.public_title || variant.title,
            available: variant.available,
            price: normalizePrice(variant.price),
            compareAtPrice: normalizePrice(variant.compare_at_price)
          };
        })
      };

      return { animals: animals, mask: mask };
    }).catch(function (error) {
      productDataPromise = null;
      throw error;
    });

    return productDataPromise;
  }

  function preloadRecommendationData() {
    if (!isEnabled()) return;
    loadCartData(false).catch(function () {});
    loadProductData().catch(function () {});
  }

  function findExistingUpsell(root) {
    if (!root || !root.querySelectorAll) return null;

    var selectors = [
      '[class*="Upsell"]',
      '[class*="upsell"]',
      '[class*="Carousel"]',
      '[class*="carousel"]',
      '[class*="Recommendation"]',
      '[class*="recommendation"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var candidates = root.querySelectorAll(selectors[i]);

      for (var j = 0; j < candidates.length; j++) {
        var candidate = candidates[j];
        if (
          candidate.id === BLOCK_ID ||
          candidate.id === SKELETON_ID ||
          candidate.id === MOUNT_ID ||
          candidate.closest('#' + BLOCK_ID) ||
          candidate.closest('#' + SKELETON_ID) ||
          candidate.closest('#' + MOUNT_ID)
        ) {
          continue;
        }

        var text = (candidate.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (text.indexOf('add more, save more') !== -1) return candidate;
      }
    }

    var nodes = root.querySelectorAll('h1, h2, h3, h4, p, span, div');
    for (var n = 0; n < nodes.length; n++) {
      var nodeText = (nodes[n].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (nodeText !== 'add more, save more') continue;

      var section = nodes[n];
      for (var depth = 0; depth < 6 && section.parentElement; depth++) {
        section = section.parentElement;
        if (section.id === 'CartPopup' || section.id === 'UpcartPopup') break;
        if (section.querySelector('img') && section.querySelector('button, a')) return section;
      }
    }

    return null;
  }

  function hideExistingUpsell(root) {
    var upsell = findExistingUpsell(root);
    if (!upsell) return null;

    if (!upsell.hasAttribute(HIDDEN_ATTR)) {
      upsell.setAttribute(HIDDEN_ATTR, upsell.style.display || '');
      upsell.style.setProperty('display', 'none', 'important');
    }

    return upsell;
  }

  function insertAfterAnchor(anchor, node) {
    if (!anchor || !anchor.parentNode || !node) return false;
    anchor.parentNode.insertBefore(node, anchor.nextSibling);
    return true;
  }

  function getStyleMountPoints() {
    var doc = getUpcartDoc();

    if (doc && doc !== document && doc.nodeType === 11 && doc.appendChild) {
      return [doc];
    }

    return [];
  }

  function getUpsellSuppressCss() {
    var cartScopes = [
      '#UpcartPopup',
      '#CartPopup',
      '#upCart',
      'upcart-drawer',
      '#upcart-drawer',
      '.upcart-drawer',
      '.upcart-cart',
      '[class*="UpcartPopup"]',
      '[class*="upcart-cart"]'
    ];
    var classPatterns = ['Upsell', 'upsell'];
    var selectors = [];

    cartScopes.forEach(function (scope) {
      classPatterns.forEach(function (pattern) {
        selectors.push(
          scope +
            ' [class*="' +
            pattern +
            '"]:not(#' +
            BLOCK_ID +
            '):not(.' +
            BLOCK_ID +
            ')'
        );
      });
    });

    return selectors.join(', ') + ' { display: none !important; }';
  }

  function injectUpsellSuppressStyles() {
    if (!isEnabled()) return;

    if (document.head && document.head.querySelector) {
      var legacyStyle = document.head.querySelector('#' + SUPPRESS_STYLE_ID);
      if (legacyStyle) legacyStyle.remove();
    }

    var css = getUpsellSuppressCss();

    getStyleMountPoints().forEach(function (mount) {
      if (!mount || !mount.querySelector) return;
      if (mount.querySelector('#' + SUPPRESS_STYLE_ID)) return;

      var style = document.createElement('style');
      style.id = SUPPRESS_STYLE_ID;
      style.textContent = css;
      mount.appendChild(style);
    });
  }

  function removeUpsellSuppressStyles() {
    getStyleMountPoints().forEach(function (mount) {
      if (!mount || !mount.querySelector) return;
      var style = mount.querySelector('#' + SUPPRESS_STYLE_ID);
      if (style) style.remove();
    });

    if (document.head && document.head.querySelector) {
      var legacyStyle = document.head.querySelector('#' + SUPPRESS_STYLE_ID);
      if (legacyStyle) legacyStyle.remove();
    }
  }

  function suppressNativeUpsell(root) {
    if (!isEnabled()) return null;
    injectUpsellSuppressStyles();
    return hideExistingUpsell(root || getCartRoot());
  }

  function restoreExistingUpsells() {
    [document, getUpcartDoc()].forEach(function (scope) {
      if (!scope || !scope.querySelectorAll) return;

      scope.querySelectorAll('[' + HIDDEN_ATTR + ']').forEach(function (upsell) {
        var originalDisplay = upsell.getAttribute(HIDDEN_ATTR);
        upsell.style.removeProperty('display');
        if (originalDisplay) upsell.style.display = originalDisplay;
        upsell.removeAttribute(HIDDEN_ATTR);
      });
    });
  }

  /* Non-animal carts: remove custom card and leave Control's native carousel. */
  function showNativeUpsellFallback() {
    removeRecommendation();
    restoreExistingUpsells();
    removeUpsellSuppressStyles();
  }

  function pauseObserver() {
    if (observer) observer.disconnect();
  }

  function getMountGlobal() {
    var root = getCartRoot();
    if (root && root.querySelector) {
      var inRoot = root.querySelector('#' + MOUNT_ID);
      if (inRoot) return inRoot;
    }

    var scopes = [getUpcartDoc(), document];
    for (var i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      if (scope && scope.getElementById) {
        var mount = scope.getElementById(MOUNT_ID);
        if (mount) return mount;
      }
    }

    return null;
  }

  function removeLegacyRecommendationNodes() {
    [document, getUpcartDoc()].forEach(function (scope) {
      if (!scope || !scope.getElementById) return;

      var skeleton = scope.getElementById(SKELETON_ID);
      if (skeleton && !(skeleton.closest && skeleton.closest('#' + MOUNT_ID))) {
        skeleton.remove();
      }

      var block = scope.getElementById(BLOCK_ID);
      if (block && !(block.closest && block.closest('#' + MOUNT_ID))) {
        block.remove();
      }
    });
  }

  function removeRecommendation() {
    removeLegacyRecommendationNodes();
    [document, getUpcartDoc()].forEach(function (scope) {
      if (!scope || !scope.getElementById) return;
      var mount = scope.getElementById(MOUNT_ID);
      if (mount) mount.remove();
    });
  }

  function ensureMount(root, anchor) {
    if (!anchor || !anchor.parentNode) return null;

    var mount = getMountGlobal();
    if (!mount) {
      mount = document.createElement('div');
      mount.id = MOUNT_ID;
      mount.className = 'upcart-cart-recommendation-mount';
      mount.setAttribute('aria-hidden', 'true');
      insertAfterAnchor(anchor, mount);
    } else if (mount.previousElementSibling !== anchor) {
      insertAfterAnchor(anchor, mount);
    }

    return mount;
  }

  function createSkeletonBlock() {
    var block = document.createElement('section');
    block.className = 'upcart-cart-recommendation upcart-cart-recommendation--skeleton';
    block.setAttribute('aria-hidden', 'true');
    block.innerHTML =
      '<div class="upcart-cart-recommendation__skeleton-heading"></div>' +
      '<div class="upcart-cart-recommendation__skeleton-line upcart-cart-recommendation__skeleton-line--wide"></div>' +
      '<div class="upcart-cart-recommendation__skeleton-line"></div>' +
      '<div class="upcart-cart-recommendation__divider"></div>' +
      '<div class="upcart-cart-recommendation__product">' +
        '<div class="upcart-cart-recommendation__skeleton-image"></div>' +
        '<div class="upcart-cart-recommendation__details">' +
          '<div class="upcart-cart-recommendation__skeleton-line upcart-cart-recommendation__skeleton-line--title"></div>' +
          '<div class="upcart-cart-recommendation__skeleton-line upcart-cart-recommendation__skeleton-line--price"></div>' +
          '<div class="upcart-cart-recommendation__skeleton-actions">' +
            '<div class="upcart-cart-recommendation__skeleton-block"></div>' +
            '<div class="upcart-cart-recommendation__skeleton-block"></div>' +
          '</div>' +
        '</div>' +
      '</div>';
    return block;
  }

  function showMountLoading(mount) {
    if (!mount) return;
    if (
      mount.dataset.state === 'loading' &&
      mount.querySelector('.upcart-cart-recommendation--skeleton')
    ) {
      return;
    }

    mount.dataset.state = 'loading';
    mount.setAttribute('aria-hidden', 'true');
    mount.innerHTML = '';
    mount.appendChild(createSkeletonBlock());
  }

  function showMountRecommendation(mount, recommendation) {
    if (!mount || !recommendation) return null;

    var signature =
      recommendation.type + ':' + recommendation.product.id + ':' + recommendation.variant.id;
    var existing = mount.querySelector('#' + BLOCK_ID);

    if (existing && existing.dataset.signature === signature) {
      mount.dataset.state = 'ready';
      mount.removeAttribute('aria-hidden');
      return existing;
    }

    var block = createRecommendationBlock(recommendation);
    block.dataset.signature = signature;
    mount.innerHTML = '';
    mount.appendChild(block);
    mount.dataset.state = 'ready';
    mount.removeAttribute('aria-hidden');
    return block;
  }

  function getSelectedVariant(product, preferredTitle) {
    var available = product.variants.filter(function (variant) {
      return variant.available;
    });

    if (!available.length) return null;

    if (preferredTitle) {
      var exact = available.find(function (variant) {
        return variant.title === preferredTitle;
      });
      if (exact) return exact;

      var preferredWeight = String(preferredTitle).match(/(\d+(?:\.\d+)?)\s*(?:lbs?|kg)/i);
      if (preferredWeight) {
        var weightMatch = available.find(function (variant) {
          return String(variant.title).indexOf(preferredWeight[0]) !== -1;
        });
        if (weightMatch) return weightMatch;
      }
    }

    return available[0];
  }

  function buildRecommendation(cart, data) {
    var animalHandles = {};
    data.animals.forEach(function (animal) {
      animalHandles[animal.handle] = true;
    });

    var paidItems = cart.items.filter(function (item) {
      return !isFreeGift(item);
    });
    var animalItems = paidItems.filter(function (item) {
      return animalHandles[item.handle];
    });
    var animalCount = animalItems.reduce(function (count, item) {
      return count + (item.quantity || 0);
    }, 0);
    var cartHandles = {};

    paidItems.forEach(function (item) {
      cartHandles[item.handle] = true;
    });

    if (animalCount === 1) {
      var animal = data.animals.find(function (product) {
        return !cartHandles[product.handle] && getSelectedVariant(product);
      });
      if (!animal) return null;

      var sourceAnimal = animalItems[0];
      var variant = getSelectedVariant(animal, sourceAnimal && sourceAnimal.variant_title);
      if (!variant) return null;

      return {
        type: 'animal',
        product: animal,
        variant: variant,
        heading: 'Add A Second Animal, Extra 10% Off Both',
        description: 'The animal in your cart gets the discount too, and both ship free',
        discountPercentage: BUNDLE_DISCOUNT
      };
    }

    if (
      animalCount >= 2 &&
      !paidItems.some(function (item) {
        return Number(item.product_id) === MASK_PRODUCT_ID || item.handle === MASK_HANDLE;
      })
    ) {
      var maskVariant = getSelectedVariant(data.mask);
      if (!maskVariant) return null;

      return {
        type: 'mask',
        product: data.mask,
        variant: maskVariant,
        heading: 'Complete Your Wind-Down',
        description: 'Add the Weighted Sleep Mask for deeper, calmer sleep. Ships free with your order',
        discountPercentage: 0
      };
    }

    return null;
  }

  function getRecommendationPrice(recommendation, variant) {
    if (recommendation.type !== 'animal') return variant.price;
    return Math.round(variant.price * (100 - recommendation.discountPercentage) / 100);
  }

  function getReferencePrice(recommendation, variant) {
    if (recommendation.type === 'animal') {
      return Math.max(variant.compareAtPrice || 0, variant.price);
    }
    return variant.compareAtPrice || 0;
  }

  function renderVariantOptions(product, selectedVariant) {
    if (
      product.variants.length === 1 &&
      String(selectedVariant.title).trim().toLowerCase() === 'default title'
    ) {
      return '';
    }

    if (product.variants.length <= 1) {
      return '<span class="upcart-cart-recommendation__variant">' +
        escapeHtml(selectedVariant.title) +
        '</span>';
    }

    return (
      '<label class="upcart-cart-recommendation__variant-label">' +
        '<span class="visually-hidden">Choose option</span>' +
        '<select class="upcart-cart-recommendation__select">' +
          product.variants.map(function (variant) {
            return (
              '<option value="' + variant.id + '"' +
                (variant.id === selectedVariant.id ? ' selected' : '') +
                (!variant.available ? ' disabled' : '') +
                '>' + escapeHtml(variant.title) + '</option>'
            );
          }).join('') +
        '</select>' +
      '</label>'
    );
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = String(value || '');
    return div.innerHTML;
  }

  function formatDescriptionHtml(value) {
    return escapeHtml(value).replace(/\bfree\b/gi, function (match) {
      return '<strong>' + match + '</strong>';
    });
  }

  function formatPriceText(cents) {
    return escapeHtml(formatMoney(cents));
  }

  function renderPriceHtml(referencePrice, salePrice) {
    if (referencePrice > salePrice) {
      return (
        '<s>' + formatPriceText(referencePrice) + '</s> ' + formatPriceText(salePrice)
      );
    }

    return formatPriceText(salePrice);
  }

  function syncRecommendationPrice(block, recommendation, variant) {
    var price = block && block.querySelector('.upcart-cart-recommendation__price');
    if (!price || !recommendation || !variant) return;

    var salePrice = getRecommendationPrice(recommendation, variant);
    var referencePrice = getReferencePrice(recommendation, variant);

    price.innerHTML = renderPriceHtml(referencePrice, salePrice);
  }

  function createRecommendationBlock(recommendation) {
    var block = document.createElement('section');
    var variant = recommendation.variant;
    var salePrice = getRecommendationPrice(recommendation, variant);
    var referencePrice = getReferencePrice(recommendation, variant);
    var hasVariantControl = !(
      recommendation.product.variants.length === 1 &&
      String(variant.title).trim().toLowerCase() === 'default title'
    );

    block.id = BLOCK_ID;
    block.className = 'upcart-cart-recommendation';
    block.dataset.type = recommendation.type;
    block.dataset.productId = recommendation.product.id;

    block.innerHTML =
      '<h3 class="upcart-cart-recommendation__heading">' +
        escapeHtml(recommendation.heading) +
      '</h3>' +
      '<p class="upcart-cart-recommendation__description">' +
        formatDescriptionHtml(recommendation.description) +
      '</p>' +
      '<div class="upcart-cart-recommendation__divider"></div>' +
      '<div class="upcart-cart-recommendation__product">' +
        '<img class="upcart-cart-recommendation__image" src="' +
          escapeHtml(normalizeImageUrl(recommendation.product.image)) +
          '" alt="" width="112" height="112">' +
        '<div class="upcart-cart-recommendation__details">' +
          '<p class="upcart-cart-recommendation__title">' +
            escapeHtml(recommendation.product.title) +
          '</p>' +
          '<p class="upcart-cart-recommendation__price">' +
            renderPriceHtml(referencePrice, salePrice) +
          '</p>' +
          '<div class="upcart-cart-recommendation__actions' +
            (hasVariantControl ? '' : ' upcart-cart-recommendation__actions--single') +
          '">' +
            renderVariantOptions(recommendation.product, variant) +
            '<button type="button" class="upcart-cart-recommendation__add" data-variant-id="' +
              variant.id + '">+ Add</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    block._recommendation = recommendation;
    return block;
  }

  function refreshUpcart() {
    document.dispatchEvent(new CustomEvent('upcart_updated'));

    if (window.UpCart) {
      if (typeof window.UpCart.refreshCart === 'function') {
        window.UpCart.refreshCart();
      } else if (typeof window.UpCart.updateCart === 'function') {
        window.UpCart.updateCart();
      }
    } else if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
    }
  }

  function addRecommendation(block, button) {
    if (!block || !button || button.disabled) return;

    var variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Adding…';

    fetchJson('/cart/add.js?upcart=1&opens_cart=maybe', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then(function () {
        refreshUpcart();
        setTimeout(scheduleRender, 100);
        setTimeout(scheduleRender, 700);
      })
      .catch(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = '+ Add';
      });
  }

  function finishRenderCycle() {
    isRendering = false;
    observeRoot();

    if (renderPending) {
      renderPending = false;
      scheduleRender();
    }
  }

  function renderRecommendation() {
    if (!isEnabled() || isRendering) return;

    var root = getCartRoot();
    if (!root) {
      waitForRoot();
      return;
    }

    isRendering = true;
    renderPending = false;
    pauseObserver();

    Promise.all([loadCartData(false), loadProductData()])
      .then(function (responses) {
        if (!isEnabled()) return;

        var recommendation = buildRecommendation(responses[0], responses[1]);

        if (!recommendation) {
          showNativeUpsellFallback();
          return;
        }

        removeLegacyRecommendationNodes();
        var upsell = suppressNativeUpsell(root) || findExistingUpsell(root);
        var mount = ensureMount(root, upsell) || getMountGlobal();

        if (mount) {
          showMountRecommendation(mount, recommendation);
        } else {
          showNativeUpsellFallback();
        }
      })
      .catch(function () {
        showNativeUpsellFallback();
      })
      .finally(function () {
        finishRenderCycle();
      });
  }

  function scheduleRender() {
    if (!isEnabled()) {
      deactivate();
      return;
    }

    if (isRendering) {
      renderPending = true;
      return;
    }

    clearTimeout(renderTimer);
    renderTimer = setTimeout(renderRecommendation, 200);
  }

  function observeRoot() {
    var root = getCartRoot();
    if (!root || !observer || !isEnabled()) return;

    observer.disconnect();
    observer.observe(root, { childList: true, subtree: true });
  }

  function isOurMutationNode(node) {
    return isIgnoredMutationElement(node);
  }

  function isIgnoredMutationElement(element) {
    if (!element || element.nodeType !== 1) return false;
    if (
      element.id === BLOCK_ID ||
      element.id === SKELETON_ID ||
      element.id === MOUNT_ID ||
      element.id === GIFT_SUMMARY_ID ||
      element.id === TRUST_SAVINGS_ID ||
      element.id === TRUST_BADGE_ID
    ) {
      return true;
    }
    if (element.hasAttribute && element.hasAttribute(HIDDEN_ATTR)) return true;
    if (element.closest) {
      if (element.closest('#' + BLOCK_ID)) return true;
      if (element.closest('#' + SKELETON_ID)) return true;
      if (element.closest('#' + MOUNT_ID)) return true;
      if (element.closest('#' + GIFT_SUMMARY_ID)) return true;
      if (element.closest('#' + TRUST_SAVINGS_ID)) return true;
      if (element.closest('#' + TRUST_BADGE_ID)) return true;
    }
    return false;
  }

  function isInternalMutation(mutation) {
    var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    if (target && isIgnoredMutationElement(target)) return true;

    var changedNodes = Array.prototype.slice.call(mutation.addedNodes)
      .concat(Array.prototype.slice.call(mutation.removedNodes));
    if (!changedNodes.length) return false;

    return changedNodes.every(function (node) {
      return isOurMutationNode(node) || isIgnoredMutationElement(node);
    });
  }

  function bindObserver() {
    if (!observer) {
      observer = new MutationObserver(function (mutations) {
        if (!isEnabled() || isRendering || renderPending) return;
        if (mutations.every(isInternalMutation)) return;

        invalidateCartData();
        scheduleRender();
      });
    }
    observeRoot();
  }

  function waitForRoot() {
    if (getCartRoot()) {
      bindObserver();
      scheduleRender();
      return;
    }
    if (rootFinder) return;

    rootFinder = setInterval(function () {
      if (!isEnabled()) return;
      if (!getCartRoot()) return;

      clearInterval(rootFinder);
      rootFinder = null;
      bindObserver();
      scheduleRender();
    }, 500);
  }

  function hookUpCartOpen() {
    if (upcartOpenHooked || !window.UpCart) return;
    upcartOpenHooked = true;

    ['open', 'openCart'].forEach(function (method) {
      if (typeof window.UpCart[method] !== 'function') return;

      var original = window.UpCart[method];
      window.UpCart[method] = function () {
        var result = original.apply(this, arguments);
        scheduleRender();
        return result;
      };
    });
  }

  function ensureUpCartOpenHook() {
    hookUpCartOpen();
    if (upcartOpenHooked || upcartHookTimer) return;

    upcartHookTimer = setInterval(function () {
      hookUpCartOpen();
      if (upcartOpenHooked) {
        clearInterval(upcartHookTimer);
        upcartHookTimer = null;
      }
    }, 200);
  }

  function deactivate() {
    clearTimeout(renderTimer);
    renderPending = false;
    removeRecommendation();
    restoreExistingUpsells();
    removeUpsellSuppressStyles();
    if (upcartHookTimer) {
      clearInterval(upcartHookTimer);
      upcartHookTimer = null;
    }
    if (observer) observer.disconnect();
    if (rootFinder) {
      clearInterval(rootFinder);
      rootFinder = null;
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      var select = event.target.closest('.upcart-cart-recommendation__select');
      if (!select || !isEnabled()) return;

      var block = select.closest('#' + BLOCK_ID);
      var recommendation = block && block._recommendation;
      if (!recommendation) return;

      var variant = recommendation.product.variants.find(function (candidate) {
        return String(candidate.id) === select.value;
      });
      if (!variant) return;

      syncRecommendationPrice(block, recommendation, variant);
      block.querySelector('.upcart-cart-recommendation__add').dataset.variantId = variant.id;
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!isEnabled()) return;

      var addButton = event.target.closest('.upcart-cart-recommendation__add');
      if (addButton) {
        event.preventDefault();
        event.stopPropagation();
        addRecommendation(addButton.closest('#' + BLOCK_ID), addButton);
        return;
      }

      if (
        event.target.closest('#cart-icon-bubble, [data-nuora-upcart-trigger], .header__icon--cart')
      ) {
        scheduleRender();
      }
    },
    true
  );

  document.addEventListener('upcart_updated', function () {
    if (!isEnabled()) return;
    invalidateCartData();
    scheduleRender();
  });

  new MutationObserver(function () {
    if (isEnabled()) {
      ensureUpCartOpenHook();
      preloadRecommendationData();
      waitForRoot();
      scheduleRender();
    } else {
      deactivate();
    }
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (!isEnabled()) return;
      ensureUpCartOpenHook();
      preloadRecommendationData();
      waitForRoot();
    });
  } else if (isEnabled()) {
    ensureUpCartOpenHook();
    preloadRecommendationData();
    waitForRoot();
  }
})();
